// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.key-features-layout{
    width: 100%;
    height: 100%;
}


.key-features-section1{
    width: 55%;
}
.keyfeatures-container{
    display: flex;
    align-items:center ;
    justify-content: space-between;
    margin: auto;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
}

.key-features-section-2{
    width: 45%;
    height: -moz-fit-content;
    height: fit-content;
}

.key-feature-section-title{
    color: white;
    font-weight: 400;
    font-size: 40px;
}

.key-feature-section-tagline{
    font-weight: 300;
    font-size: 38px;
}

.key-feature-section-description{
    font-size: 24px;
    color: white;
}

.key-features-title{
    font-weight: bolder;
    font-size: 40px;
}

.key-features-image-container{
    width: 45%;
    height: 300px;
    background-color: black;
}

.py-4{
    width: 40%;
}

.wid{
    width: 60%;
}

.key-feature-section-divider{
    background-color: #F8C102;
    border-radius: 20px;
    height: 3px;
    width: 80%;
}
.tab-view-btns{
    background: none;
    border: none; /* Remove borders from buttons */
    cursor: pointer;
    outline: none; /* Remove outline on focus */
    transition: color 0.3s ease;
    width: max-content;
    padding: 10px 40px;
    font-size: 16px;
    color: grey;
}




/* Animation for tabs */
@keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }


  .tab-underline {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 5px;
    border-radius: 20px;    background-color: #0094DC;
    ; /* Set color of underline */
    transition: width 0.3s ease, left 0.3s ease; /* Add transition for smooth animation */
  }
  .tab-container {
    position: relative;
  }
  
  /* Animation for tab loading */
  .tab-container .flex button {
    animation: fadeIn 0.5s ease forwards; /* Apply fade-in animation to buttons */
  }  


  @media screen and (max-width: 600px) {
    .key-feature-section-title{
        font-size: 22px;
    }
    .key-features-section1{
        width: 100%;
    }
    .key-feature-section-description{
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Demographics/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,wBAAmB;IAAnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,YAAY,EAAE,gCAAgC;IAC9C,eAAe;IACf,aAAa,EAAE,4BAA4B;IAC3C,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;;;;AAKA,uBAAuB;AACvB;IACI;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;;EAGA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,mBAAmB,KAAK,yBAAyB;MAC/C,2BAA2B;IAC7B,2CAA2C,EAAE,wCAAwC;EACvF;EACA;IACE,kBAAkB;EACpB;;EAEA,8BAA8B;EAC9B;IACE,oCAAoC,EAAE,uCAAuC;EAC/E;;;EAGA;IACE;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".key-features-layout{\n    width: 100%;\n    height: 100%;\n}\n\n\n.key-features-section1{\n    width: 55%;\n}\n.keyfeatures-container{\n    display: flex;\n    align-items:center ;\n    justify-content: space-between;\n    margin: auto;\n    width: 100%;\n    height: fit-content;\n}\n\n.key-features-section-2{\n    width: 45%;\n    height: fit-content;\n}\n\n.key-feature-section-title{\n    color: white;\n    font-weight: 400;\n    font-size: 40px;\n}\n\n.key-feature-section-tagline{\n    font-weight: 300;\n    font-size: 38px;\n}\n\n.key-feature-section-description{\n    font-size: 24px;\n    color: white;\n}\n\n.key-features-title{\n    font-weight: bolder;\n    font-size: 40px;\n}\n\n.key-features-image-container{\n    width: 45%;\n    height: 300px;\n    background-color: black;\n}\n\n.py-4{\n    width: 40%;\n}\n\n.wid{\n    width: 60%;\n}\n\n.key-feature-section-divider{\n    background-color: #F8C102;\n    border-radius: 20px;\n    height: 3px;\n    width: 80%;\n}\n.tab-view-btns{\n    background: none;\n    border: none; /* Remove borders from buttons */\n    cursor: pointer;\n    outline: none; /* Remove outline on focus */\n    transition: color 0.3s ease;\n    width: max-content;\n    padding: 10px 40px;\n    font-size: 16px;\n    color: grey;\n}\n\n\n\n\n/* Animation for tabs */\n@keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n\n  .tab-underline {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    height: 5px;\n    border-radius: 20px;    background-color: #0094DC;\n    ; /* Set color of underline */\n    transition: width 0.3s ease, left 0.3s ease; /* Add transition for smooth animation */\n  }\n  .tab-container {\n    position: relative;\n  }\n  \n  /* Animation for tab loading */\n  .tab-container .flex button {\n    animation: fadeIn 0.5s ease forwards; /* Apply fade-in animation to buttons */\n  }  \n\n\n  @media screen and (max-width: 600px) {\n    .key-feature-section-title{\n        font-size: 22px;\n    }\n    .key-features-section1{\n        width: 100%;\n    }\n    .key-feature-section-description{\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
